<h2 mat-dialog-title>GUID Picker</h2>
<mat-dialog-content class="content">
  <mat-form-field appearance="outline">
    <mat-label>Field Key</mat-label>
    <input matInput [(ngModel)]="fieldKey" (ngModelChange)="onFieldKeyChange()" placeholder="e.g. brandId, userId">
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Lookup Source</mat-label>
    <mat-select [(ngModel)]="sourceKey" (selectionChange)="onSourceChange()">
      @for (source of sources; track source) {
        <mat-option [value]="source.key">{{source.label}}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Search</mat-label>
    <input matInput [(ngModel)]="query" (ngModelChange)="onQueryChange()" placeholder="Type to filter">
  </mat-form-field>

  @if (loading) {
    <div class="status">Loading...</div>
  }
  @if (errorMessage) {
    <div class="status error">{{errorMessage}}</div>
  }

  <mat-list>
    @for (item of results; track trackById($index, item)) {
      <mat-list-item (click)="insertItem(item)">
        <div class="item">
          <div class="label">{{item.label || '(no label)'}}</div>
          <div class="id">{{item.id}}</div>
        </div>
      </mat-list-item>
    }
    @if (!loading && results.length === 0) {
      <div class="empty">No matches.</div>
    }
  </mat-list>

  @if (selected) {
    <mat-card class="selected">
      <mat-card-title>Selected</mat-card-title>
      <mat-card-content>
        <div class="label">{{selected.label}}</div>
        <div class="id">{{selected.id}}</div>
        <div class="actions">
          <button mat-raised-button color="primary" (click)="insertSelected()">Insert</button>
          <button mat-stroked-button (click)="copySelected()">Copy</button>
        </div>
      </mat-card-content>
    </mat-card>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="close()">Close</button>
</mat-dialog-actions>
